import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Vue from 'vue'

const Fingerprint = (async () => {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  Vue.prototype.$FingerprintJS = result.visitorId
})()
export default Fingerprint
